import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";
import Slideshow from "../../assets/Slideshow/Slideshow";
import "./SchoolProjects.css";


import jewelleryweb1 from "../../assets/Images/jewelleryweb/1.png"
import jewelleryweb2 from "../../assets/Images/jewelleryweb/2.png"
import jewelleryweb4 from "../../assets/Images/jewelleryweb/3.png"

import jewelleryweb3 from "../../assets/Videos/3.mp4"



const JewelleryWebshop = () => {
  // Replace with your real images later:
  // - moodboard (summer vibe / Cyclades)
  // - wireframes / prototypes (low-mid-hi)
  // - persona + survey/interview snippets
  // - final website pages (home, catalog, gallery, contact/custom order)
  // - final pitch/video suggestion screenshots
  const images = [jewelleryweb1,jewelleryweb2,jewelleryweb4,jewelleryweb3];

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="page-container">
      <Navbar />

      <div className="content-lo1-headings">
        <h1>Jewellery Webshop</h1>
        <p>
          A client website project for <b>Alex Tsonev</b>, focused on rebranding his jewellery store with a
          fresh summer vibe, clear product browsing, and a strong story behind the craft.
        </p>
      </div>

      <div className="line"></div>

      <div className="breadcrumb-wrap" style={{ padding: "0.1rem 7.5rem" }}>
        <BreadcrumbHeader />
      </div>

      <div className="content-lo1">
        <div className="tweekracht-layout">
          {/* LEFT: Case Study Content */}
          <div className="tweekracht-left">
            {/* Quick nav / anchors */}
            <div className="tweekracht-anchors">
              <button onClick={() => scrollToId("overview")}>Overview</button>
              <button onClick={() => scrollToId("client")}>Client</button>
              <button onClick={() => scrollToId("requirements")}>Requirements</button>
              <button onClick={() => scrollToId("process")}>Process</button>
              <button onClick={() => scrollToId("contribution")}>My Contribution</button>
              <button onClick={() => scrollToId("reflection")}>Reflection</button>
            </div>

            <section id="overview" className="tweekracht-section">
              <h2>Project Overview</h2>
              <p>
                This project was built for <b>Alex Tsonev</b>, a jeweller with over 13 years of experience and a
                brand inspired by nature. The goal was to refresh and rebrand his online presence by creating a
                new website with a <b>summer vibe</b> that matches his audience and highlights the craftsmanship
                behind the jewellery.
              </p>
              <p>
                The website needed to make products easy to explore, separate items by price (low → high), include
                a gallery, and clearly show how the jewellery is made. The platform also needed to support contact
                and custom order requests.
              </p>
            </section>

            <section id="client" className="tweekracht-section">
              <h2>Client Context</h2>
              <p>
                Alex’s jewellery is heavily inspired by nature his work includes organic forms, textures, and unique
                processes that turn natural objects into silver and gold shapes. His audience includes people from
                different age groups, including <b>hipsters</b> and the <b>LGBTQ community</b>.
              </p>
              <p>
                Because the brand is expressive and artistic, the website design had to feel visually strong while
                still being easy to use as a webshop.
              </p>
            </section>

            <section id="requirements" className="tweekracht-section">
              <h2>Key Requirements</h2>
              <ul>
                <li>
                  <b>Summer vibe / aesthetic direction</b> (inspired by Cyclades islands)
                </li>
                <li>
                  <b>Product browsing</b> that feels simple and fast
                </li>
                <li>
                  <b>Price-based sections</b> from low to high
                </li>
                <li>
                  <b>Gallery</b> of products
                </li>
                <li>
                  <b>“How it’s made” showcase</b> to highlight craftsmanship
                </li>
                <li>
                  <b>Contact / custom order flow</b> so customers can request personalized pieces
                </li>
              </ul>
            </section>

            <section className="tweekracht-section">
              <h2>Project Snapshot</h2>
              <div className="tweekracht-snapshot">
                <div className="snapshot-item">
                  <span className="snapshot-label">Client</span>
                  <span className="snapshot-value">Alex Tsonev (Jewellery Brand)</span>
                </div>
                <div className="snapshot-item">
                  <span className="snapshot-label">Goal</span>
                  <span className="snapshot-value">Rebrand + build a summer-themed website/webshop</span>
                </div>
                <div className="snapshot-item">
                  <span className="snapshot-label">Audience</span>
                  <span className="snapshot-value">Wide age range, hipsters, LGBTQ community</span>
                </div>
                <div className="snapshot-item">
                  <span className="snapshot-label">Approach</span>
                  <span className="snapshot-value">Scrum iterations + Design Thinking (Empathize → Test)</span>
                </div>
                <div className="snapshot-item">
                  <span className="snapshot-label">Collaboration</span>
                  <span className="snapshot-value">Figma + meetings + GitLab branching workflow</span>
                </div>
              </div>
            </section>

            <section id="process" className="tweekracht-section">
              <h2>Process</h2>

              <h3>Research & Discovery (Empathize)</h3>
              <ul>
                <li>Defined the target audience and what they expect from a jewellery website</li>
                <li>Explored what information customers want before buying jewellery online</li>
                <li>Started visual research for a summer vibe (Cyclades-inspired look and feel)</li>
              </ul>

              <h3>Define</h3>
              <ul>
                <li>Identified user problems (navigation, trust, clarity, product discovery)</li>
                <li>Created personas to keep decisions user-centered</li>
              </ul>

              <h3>Ideation</h3>
              <ul>
                <li>Brainstormed ways to showcase the collection and the making process</li>
                <li>Explored structure and categories to make products easier to find</li>
              </ul>

              <h3>Prototyping & Testing</h3>
              <ul>
                <li>Worked on low, mid, and high fidelity prototypes</li>
                <li>Used feedback loops (client/teacher/user) to improve each iteration</li>
              </ul>
            </section>

            <section id="contribution" className="tweekracht-section">
              <h2>My Contribution</h2>
              <ul>
                <li>Helped create the <b>team charter</b> to set clear agreements and collaboration rules</li>
                <li>Contributed to the <b>project plan</b> by documenting scope, approach, research, risks, and workflow</li>
                <li>Helped write <b>interview questions</b> to understand user needs and expectations</li>
                <li>Supported persona creation and used it to guide interviews and design decisions</li>
                <li>Assisted with <b>prototype development</b> and iteration based on feedback</li>
                <li>Helped create a <b>video suggestion website</b> for the client as part of the final delivery</li>
              </ul>
            </section>

            <section id="reflection" className="tweekracht-section">
              <h2>What Did I Learn?</h2>
              <p>
                This project taught me how to work with a real client and translate brand needs into a clear website direction.
                I learned that a strong aesthetic (like a summer vibe) only works when it’s backed by good usability: clear structure,
                easy product discovery, and the right information at the right moment.
              </p>
              <p>
                I also improved my teamwork skills by contributing to documentation and research deliverables like the team charter,
                project plan, and interview questions. Creating personas helped me stay focused on real user expectations instead of
                only designing based on personal taste.
              </p>
            </section>
          </div>

          {/* RIGHT: Sticky Slideshow */}
          <aside className="tweekracht-right">
            {images.length > 0 ? (
              <Slideshow images={images} />
            ) : (
              <div className="slideshow-placeholder">
                <p>Slideshow Placeholder</p>
                <p>Add images to the images array to display slideshow</p>
              </div>
            )}

            <div className="tweekracht-caption">
              <p>
                
              </p>
            </div>
          </aside>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default JewelleryWebshop;
